/**
 * Browser bootstrap. Hydrates every <clientEntry /> island on the page.
 */
import { run } from 'remix/component'

const app = run({
  async loadModule(moduleUrl: string, name: string) {
    const mod = await import(moduleUrl)
    if (!mod) throw new Error(`Unknown module: ${moduleUrl}`)
    const Component = mod[name]
    if (!Component) throw new Error(`Unknown component: ${moduleUrl}#${name}`)
    return Component
  },
})

app.ready().catch((error: unknown) => {
  console.error('hydration failed:', error)
})
